import TextField, {TextFieldProps} from '@mui/material/TextField';

import {styled} from '@mui/material/styles';

export const CTextField = styled(TextField)<TextFieldProps>(
  (/* { theme } */) => ({
  }),
);